<template>
  <long-query-layout
    :resource-name="resourceName"
    :query-filter="queryFilter"
    :map-query-filter-for-api="mapQueryFilterForApi"
    :apply-query-filter="applyQueryFilter"
    :active-tab.sync="activeTab"
    :no-excel-download="true"
    :disable-reservation="true"
    @query-completed="onQueryCompleted"
  >
    <!-- -------------------------------------------------------- -->
    <!-- 分析条件 -->
    <!-- -------------------------------------------------------- -->
    <template v-slot:filter>
      <!-- 商品 -->
      <query-filter-element
        id="item-heron"
        title="商品リスト"
        contentWidth="large"
      >
        <gl-select-company :company.sync="queryFilter.item.company" />
        <file-upload
          :file-load-function="loadItems"
          @loaded="
            queryFilter.item.table = $event.loadResult.table.name
            queryFilter.item.filename = $event.filename
          "
        />
        <div>
          <gl-sub-text>商品リストファイルのコード種別</gl-sub-text>
        </div>
        <div>
          <div>
            <md-radio v-model="queryFilter.item.itemCodeType" value="1">
              商品コード（他分析でも参照されるデフォルトの商品コード）
            </md-radio>
          </div>
          <div>
            <md-radio v-model="queryFilter.item.itemCodeType" value="2">
              商品コード2
            </md-radio>
          </div>
          <div>
            <md-radio v-model="queryFilter.item.itemCodeType" value="3">
              商品コード3
            </md-radio>
          </div>
        </div>
        <blockquote class="blockquote">
          「商品コード2」および「商品コード3」が表すコードの種別（通常SKUコードなどはこれらに割り振られています）については御社システム管理者にお問い合わせください。
        </blockquote>
      </query-filter-element>

      <!-- 顧客 -->
      <query-filter-element id="customer-heron" title="顧客コードリスト">
        <file-upload
          :file-load-function="loadCustomers"
          @loaded="
            queryFilter.customer.table = $event.loadResult.table.name
            queryFilter.customer.filename = $event.filename
          "
        />
      </query-filter-element>

      <!-- 期間 -->
      <query-filter-element
        id="term"
        title="購買履歴検索期間"
        contentWidth="medium"
      >
        <filter-term v-bind.sync="queryFilter.term" />
      </query-filter-element>

      <!-- オプション -->
      <query-filter-element
        id="option-heron"
        title="オプション"
        contentWidth="large"
      >
        <filter-option-heron
          :itemCategoryLevels="itemCategoryLevels"
          :date-from="queryFilter.term.dateFrom"
          :date-to="queryFilter.term.dateTo"
          v-bind.sync="queryFilter.option"
          @previous-recommend="
            queryFilter.option.previousRecommend.table = $event
          "
          @previous-recommend-filename="
            queryFilter.option.previousRecommendFilename = $event
          "
        />
      </query-filter-element>
    </template>

    <!-- -------------------------------------------------------- -->
    <!-- 分析結果 -->
    <!-- -------------------------------------------------------- -->
    <template v-slot:result>
      <div>
        <h1>
          <a class="download-link" href="#" @click.prevent="download">
            レコメンドCSVダウンロード
          </a>
        </h1>
      </div>
      <hr />
      <div class="summary">
        <p>
          固定商品が割り当てられた顧客数（
          <a href="#" @click.prevent="downloadSummary">CSV</a>
          ）
        </p>
        <p>
          <gl-table ref="resultTable" v-bind="resultTable.result" />
        </p>
        <p>
          割り当てられた顧客数（各商品）（
          <a href="#" @click.prevent="downloadItem">CSV</a>
          ）
        </p>
        <p>
          <gl-table ref="itemTable" v-bind="resultTable.item" />
        </p>
        <p>
          割り当てられた顧客数（各分類。「提案商品分類ダブり回避」で指定した階層。指定していない場合は最下層）（
          <a href="#" @click.prevent="downloadCategory">CSV</a>
          ）
        </p>
        <p>
          <gl-table ref="categoryTable" v-bind="resultTable.category" />
        </p>
      </div>
    </template>
  </long-query-layout>
</template>

<script>
// 分析条件, 分析結果のためのレイアウト
import LongQueryLayout from '@/components/layout/LongQueryLayout.vue'
// 分析条件
import QueryFilterElement from '@/components/QueryFilterElement.vue'
import FilterTerm from '@/components/FilterTerm.vue'
import FilterOptionHeron from '@/components/FilterOptionHeron.vue'
import FileUpload from '@/components/common/FileUpload.vue'

import GlTable from '@/components/GlTable.vue'

// 分析条件モデル
import term from '@/queryfilter/term'

import repository from '@/repositories/Repository'
import download from '@/util/download'

export default {
  components: {
    QueryFilterElement,
    FilterTerm,
    FilterOptionHeron,
    FileUpload,
    LongQueryLayout,
    GlTable,
  },
  props: {},
  data() {
    return {
      resourceName: 'heron',
      /**
       * 表示タブ（分析条件、分析結果）
       *
       * 表示タブをプログラム側から切り替えたい場合をこれを使います。
       */
      activeTab: undefined,
      /**
       * 分析条件
       */
      queryFilter: {
        item: {
          order: 1,
          summaryKey: 'itemHeron',
          company: null,
          table: null,
          filename: null,
          itemCodeType: '1',
          errors: [],
        },
        customer: {
          order: 2,
          summaryKey: 'customerHeron',
          table: null,
          filename: null,
          errors: [],
        },
        term: { order: 3, ...term.get() },
        option: {
          order: 4,
          summaryKey: 'optionHeron',
          // 直近性考慮
          recency: null,
          // 直近性考慮期間
          existsStockFromDate: null,
          // 固定商品
          fixedItems: [],
          // 前回提案ファイル
          previousRecommend: {
            table: null,
          },
          previousRecommendFilename: null,
          // 提案順
          recommendOrder: [
            { label: '購買総金額', value: 'amount' },
            { label: '購買総点数', value: 'qty' },
            { label: '最終購買日', value: 'last_sale' },
            { label: '購買回数', value: 'receipt_count' },
          ],
          // 提案商品ダブリ回避
          categoryRedundant: null,
          enclosure: null,
          errors: [],
        },
      },
      resultTable: {
        result: {
          columns: undefined,
          groupHeaders: undefined,
          sortColumnName: 'default_count',
          sortOrder: 'asc',
          url: undefined,
        },
        item: {
          height: 200,
          columns: undefined,
          groupHeaders: undefined,
          sortColumnName: 'item_code',
          sortOrder: 'asc',
          url: undefined,
        },
        category: {
          height: 200,
          columns: undefined,
          groupHeaders: undefined,
          sortColumnName: 'category_code',
          sortOrder: 'asc',
          url: undefined,
        },
      },
      // 結果のダウンロード用
      currentQueryId: undefined,
      /**
       * この画面が持つ分析条件を、クエリのペイロードに変換する
       */
      mapQueryFilterForApi: queryFilter => {
        return {
          company: queryFilter.item.company,
          itemCodeType: queryFilter.item.itemCodeType,
          tables: {
            item: queryFilter.item.table,
            customer: queryFilter.customer.table,
            previousRecommend: queryFilter.option.previousRecommend.table,
          },
          term: term.mapToApiPayload(queryFilter.term),
          option: {
            recency: queryFilter.option.recency,
            fixedItems: queryFilter.option.fixedItems.map(i => i),
            existsStockFromDate: queryFilter.option.existsStockFromDate,
            recommendOrder: queryFilter.option.recommendOrder.map(r => r.value),
            categoryRedundant: queryFilter.option.categoryRedundant,
            enclosure: queryFilter.option.enclosure,
          },
        }
      },
      /**
       * 渡された分析条件をこの画面の分析条件に反映する
       * アップロードファイルはテーブルデータの生存期間がサーバー側
       * 次第なので復元しません。
       */
      applyQueryFilter: queryFilter => {
        this.queryFilter.item.company = queryFilter.item.company
        this.queryFilter.item.itemCodeType =
          queryFilter.item.itemCodeType || '1'
        term.applyPayload(this.queryFilter.term, queryFilter.term)
        this.queryFilter.option.recency = queryFilter.option.recency
        // 直近性考慮期間は通常運用では分析期間の直近1週間なので復元はしません。
        this.queryFilter.option.fixedItems = queryFilter.option.fixedItems
        this.queryFilter.option.recommendOrder =
          queryFilter.option.recommendOrder
        this.queryFilter.option.categoryRedundant =
          queryFilter.option.categoryRedundant
        this.queryFilter.option.enclosure = queryFilter.option.enclosure
      },
      loadItems: async id => {
        const repo = this.$repositories.get('uploadFile')
        const result = await repo.loadFile(id, [
          { name: 'org_item_code', type: 'STRING' },
        ])
        return result
      },
      loadCustomers: async id => {
        const repo = this.$repositories.get('uploadFile')
        const result = await repo.loadFile(id, [
          { name: 'card_id', type: 'STRING' },
        ])
        return result
      },
    }
  },
  computed: {
    itemCategoryLevels() {
      const company = this.queryFilter.item.company
      if (company) {
        return this.$store.state.itemCategoryLevels[company]
      }
      return []
    },
  },
  watch: {
    'queryFilter.item.filename': {
      immediate: true,
      handler(value) {
        if (!value) {
          this.queryFilter.item.errors = ['ファイルを選択してください']
        } else {
          this.queryFilter.item.errors = []
        }
      },
    },
    'queryFilter.customer.filename': {
      immediate: true,
      handler(value) {
        if (!value) {
          this.queryFilter.customer.errors = ['ファイルを選択してください']
        } else {
          this.queryFilter.customer.errors = []
        }
      },
    },
  },
  methods: {
    async onQueryCompleted(queryInfo) {
      this.currentQueryId = queryInfo.id

      const colModel = key =>
        repository.giggle
          .get(
            this.$longQuery.getColModelFetchUrl(
              this.resourceName,
              queryInfo.id,
              key,
            ),
          )
          .then(r => r.data)

      const url = key =>
        this.$longQuery.getQueryResultFetchUrl(
          this.resourceName,
          queryInfo.id,
          key,
        )

      this.resultTable.result.columns = (await colModel('result')).colModel
      this.resultTable.result.url = await url('result')

      this.resultTable.item.columns = (await colModel('item')).colModel
      this.resultTable.item.url = await url('item')

      this.resultTable.category.columns = (await colModel('category')).colModel
      this.resultTable.category.url = await url('category')
    },
    async download() {
      const downloadUrl = await this.$longQuery.queryGiggleResource(baseUrl => {
        return `${baseUrl}${this.resourceName}/${this.currentQueryId}/download`
      })
      window.open(downloadUrl)
    },
    async downloadStatsCsv(columns, dataUrl, filename) {
      const header = columns.map(c => ({
        colName: c.colName,
        headerText: c.headerText,
      }))

      const data = await repository.giggle.get(dataUrl).then(r => r.data)

      const body = data.rows
        .map(r => {
          return header.map(h => r[h.colName]).join(',')
        })
        .join('\n')

      download(header.map(h => h.headerText) + '\n' + body, filename)
    },
    async downloadSummary() {
      await this.downloadStatsCsv(
        this.resultTable.result.columns,
        this.resultTable.result.url,
        '固定商品.csv',
      )
    },
    async downloadItem() {
      await this.downloadStatsCsv(
        this.resultTable.item.columns,
        this.resultTable.item.url,
        '商品毎顧客数.csv',
      )
    },
    async downloadCategory() {
      await this.downloadStatsCsv(
        this.resultTable.category.columns,
        this.resultTable.category.url,
        'カテゴリ毎顧客数.csv',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.download-link {
  font-size: var(--font-size-large);
}
</style>
